import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'

import { isAdminAuthFailure } from '@gto/api-client'
import { logSentry } from '@gto/sentry'

// React Query's own default, kept explicit because the predicate below has to
// restate it once it takes over the decision.
const MAX_QUERY_RETRIES = 3

// One central Sentry hook for ALL query and mutation failures. Each isError UI
// branch and each mutation onError then only renders the fallback — no
// per-page useEffect, no per-hook report, no missing copies.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Never retry an auth failure. The DOAT interceptor has already spent its
      // one refresh-and-retry and logged the user out by the time the error gets
      // here, so React Query's default three attempts can only re-run a request
      // that cannot succeed — and each attempt costs another logout + redirect.
      // This is the amplifier half of C-1820: 4 attempts per query, times every
      // query mounted on the page.
      retry: (failureCount, error) =>
        !isAdminAuthFailure(error) && failureCount < MAX_QUERY_RETRIES,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      logSentry(`admin-web: query failed (${String(query.queryKey)})`, error)
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      logSentry(`admin-web: mutation failed (${String(mutation.options.mutationKey)})`, error)
    },
  }),
})
